import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../ColorConstants";
import { Text } from "../TextConstants";
import SignupForm from "../components/SignUp/SignUpForm";
import { EVENT } from "../analytics/constants";
import { trackFBEvent } from "../analytics";
const loginBg = require("../assets/images/Loginbg.png");

const SignUp = () => {
  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "SignUp Page" });
  }, []);
  return (
    <SignUpStyled>
      <SignUpModal>
        <InnerDiv>
          <Logo src={require("../assets/images/lww_logo.png")} alt="logo" />
          <HeaderRight>{Text.signUpHeader}</HeaderRight>
          <SubHeaderRight>{Text.signUpSubHeader}</SubHeaderRight>
          <SignupForm />
        </InnerDiv>
      </SignUpModal>
    </SignUpStyled>
  );
};
export default SignUp;

const SignUpStyled = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-image: url(${loginBg}); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  @media only screen and (max-width: 768px) {
    height: fit-content;
  }
  @media only screen and (max-height: 790px) {
    height: fit-content;
  }
`;
const SignUpModal = styled.div`
  width: 31.7rem;
  border-radius: 0.5rem;
  padding-bottom: 1rem;
  background: ${Colors.whiteSmoke};

  @media only screen and (max-width: 768px) {
    height: fit-content;
    box-sizing: border-box;
    width: 100vw;
    height: fit-content;
    border-radius: 0;
    display: flex;
    justify-content: center;
    @media only screen and (min-height: 760px) {
      height: fit-content;
      box-sizing: border-box;
      width: 100vw;
      height: 100vh;
      border-radius: 0;
      display: flex;
      justify-content: center;
    }
  }
`;
const InnerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media only screen and (max-width: 768px) {
    justify-content: center;
  }
`;
const Logo = styled.img`
  width: 22rem;
  resize: contain;
  @media only screen and (max-width: 768px) {
    margin: 0rem 0;
  }
`;
const HeaderRight = styled.div`
  font-family: "Poppins";
  font-weight: 600;
  font-size: 1.5rem;
  color: ${Colors.black};
  margin-top: 1.875rem;
`;
const SubHeaderRight = styled.div`
  font-family: "Poppins";
  font-size: 0.875rem;
  color: ${Colors.black};
  margin-top: 0.5625rem;
  margin-bottom: 1.6875rem;
`;
